export const CardSettings = {
    Title: 'Title',
    Description: 'Description',
    TimeSensitivity: 'Time Sensitivity Description',
    TimeRange: 'Time Range',
    Distance: 'Distance',
    Score: 'Score',
    Radius: 'radius'
};
